import React, {Component} from 'react';
import {Input, Grid} from 'react-spreadsheet-grid';
import set from 'lodash.set';
import authService from "../api-authorization/AuthorizeService";
import Select, {components, DropdownIndicatorProps} from 'react-select';
import {Button, Form} from "react-bootstrap";
import {Collapse} from "react-collapse";
import arrow_up from "../../assets/icons/dark_arrow_up.png";
import arrow_down from "../../assets/icons/dark_arrow_down.png";
import {Typography} from "@material-ui/core";

export class PredecessorTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columnsRegion: [],
        };
        this.handleChangeSelectCrops = this.handleChangeSelectCrops.bind(this)
        this.handleChangeSelectFertilizer = this.handleChangeSelectFertilizer.bind(this)
        this.handleChangeYieldFact = this.handleChangeYieldFact.bind(this)
    }

    componentDidMount() {
        this.populateFieldsData();
    }

    handleChangeSelectCrops(e) {
        // eslint-disable-next-line array-callback-return
        this.props.field[0].regions.map((region) => {
            region.residue.cropId = e.value;
        });
        this.props.onPredecessorChange(true);
    }

    handleChangeSelectFertilizer(e) {
        // eslint-disable-next-line array-callback-return
        this.props.field[0].regions.map((region) => {
            region.residue.fertilizerOrganicId = e.value;
            region.residue.fertilizerOrganic = this.props.fertilizers.find((f) => {
                return f.id === e.value;
            })
        });
        this.props.onPredecessorChange(true);
    }

    handleChangeYieldFact(e) {
        if (e.key === 'Enter') {
            // eslint-disable-next-line array-callback-return
            this.props.field[0].regions.map((region) => {
                region.residue.yield = e.target.value;
            })
            this.props.onPredecessorChange(true);
        }
    }


    static renderTable(columns, field, crop_list, fertilizers_organic_list, addRow, columnsRegion, handleChangeSelectCrops, handleChangeYieldFact, handleChangeSelectFertilizer, expand, isExpand) {
        let row = field.length !== 0 ? field[0].regions : [];
        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет данных</Typography>;
        }

        return (
            row.length !== 0 ?
                <div className='predecessor-label'>
                    <div className="label-btn-container">
                        <Button className="label-button" onClick={expand}>
                            Предшествующая культура
                            <img src={isExpand ? arrow_up : arrow_down} className='btn-arrow' alt='arrow'/>
                        </Button>
                    </div>
                    <Collapse isOpened={isExpand}>
                        <div id="predecessor-table">
                            <table className="header-predecessor-table">
                                <thead className="align-middle">
                                <tr>
                                    <th style={{width: "5.95%"}} className="align-middle" scope="col"
                                        rowSpan="2">Наим.<br/> эл. уч.
                                    </th>
                                    <th style={{width: "8%"}} className="align-middle" scope="col"
                                        rowSpan="2">Площадь, га
                                    </th>
                                    <th style={{width: "18%"}} scope="col">Культура</th>
                                    <th style={{width: "8%"}} scope="col">Факт. урож.,ц/га</th>
                                    <th style={{width: "30%"}} scope="col" colSpan="2">Орг. удобрения внесенные под предшественник</th>
                                    <th style={{width: "30%"}} scope="col" colSpan="6">Кол-во мин. удобрений внесенных под предшественник, д.в. кг/га</th>
                                </tr>
                                <tr>
                                    <th style={{width: "17.95%"}} scope="col">
                                            <Select
                                                maxMenuHeight="245px"
                                                components={{DropdownIndicator, NoOptionsMessage}}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    border: '1px solid #ABB3D1',
                                                    borderRadius: '10px',
                                                    colors: {
                                                        ...theme.colors,
                                                        primary: '#ABB3D1',
                                                    },
                                                })}
                                                styles={{
                                                    container: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        width: '90%',
                                                        margin: '0 auto',
                                                        height: '45px',
                                                    }),
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        background: state.isFocused ? '#fff' : '#E9EAEE',
                                                        height: '45px',
                                                        width: '100%',
                                                    }),
                                                    menu: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        border: ' 1px solid #ABB3D1',
                                                        borderRadius: '10px',
                                                        margin: '0',
                                                    }),
                                                    option: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        color: '#201E44',
                                                        minHeight: '45px',
                                                        height: 'fit-content',
                                                        overflow: 'hidden',
                                                        wordWrap: 'break-word',
                                                        lineHeight: '22px',
                                                        backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                                    }),
                                                    menuList: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        paddingRight: '13px !important',
                                                        "::-webkit-scrollbar":{
                                                            width: '3px !important'
                                                        },
                                                        "::-webkit-scrollbar-track": {
                                                            background: '#E2E4EF !important',
                                                            borderRadius: '6px !important'
                                                        },
                                                        "::-webkit-scrollbar-thumb":{
                                                            background: ' #ABB3D1 !important',
                                                            borderRadius: '6px !important'
                                                        },
                                                        "::-webkit-scrollbar-thumb:hover":{
                                                            background: ' #ABB3D1 !important',
                                                        }
                                                    })
                                                }}
                                                options={crop_list}
                                                placeholder='Выберите культуру'
                                                defaultValue={crop_list[crop_list.findIndex((r) => r.value === row[0].residue.cropId)]}
                                                onChange={handleChangeSelectCrops}
                                            />
                                    </th>
                                    <th style={{width: "8%"}} scope="col">
                                        <Form className="fact-yield-form">
                                            <Form.Control placeholder='0' onKeyDown={handleChangeYieldFact}/>
                                        </Form>
                                    </th>
                                    <th style={{width: "24.02% !important"}} scope="col">
                                            <Select
                                                maxMenuHeight="260px"
                                                components={{DropdownIndicator, NoOptionsMessage}}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    border: '1px solid #ABB3D1',
                                                    borderRadius: '10px',
                                                    colors: {
                                                        ...theme.colors,
                                                        primary: '#ABB3D1',
                                                    },
                                                })}
                                                styles={{
                                                    container: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        margin: '0 auto',
                                                        width: '90%',
                                                        height: '45px',
                                                    }),
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        background: state.isFocused ? '#fff' : '#E9EAEE',
                                                        height: '45px',
                                                        width: '100%',
                                                    }),
                                                    menu: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        border: ' 1px solid #ABB3D1',
                                                        borderRadius: '10px',
                                                        margin: '0',
                                                    }),
                                                    option: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        overflow: "hidden",
                                                        height: 'fit-content',
                                                        minHeight: '45px',
                                                        wordWrap: 'break-word',
                                                        lineHeight: '22px',
                                                        backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                                    }),
                                                    menuList: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        paddingRight: '13px !important',
                                                        "::-webkit-scrollbar":{
                                                            width: '3px !important'
                                                        },
                                                        "::-webkit-scrollbar-track": {
                                                            background: '#E2E4EF !important',
                                                            borderRadius: '6px !important'
                                                        },
                                                        "::-webkit-scrollbar-thumb":{
                                                            background: ' #ABB3D1 !important',
                                                            borderRadius: '6px !important'
                                                        },
                                                        "::-webkit-scrollbar-thumb:hover":{
                                                            background: ' #ABB3D1 !important',
                                                        }
                                                    })
                                                }}
                                                placeholder='Выберите удобрение'
                                                defaultValue={fertilizers_organic_list[fertilizers_organic_list.findIndex((r) => r.value === row[0].residue.fertilizerOrganicId)]}
                                                options={fertilizers_organic_list}
                                                onChange={handleChangeSelectFertilizer}
                                            />
                                    </th>
                                    <th style={{width: "6%"}} scope="col">Кол-во,<br/>т/га</th>
                                    <th style={{width: "5%"}} scope="col">N<br/></th>
                                    <th style={{width: "5%"}} scope="col">P₂O₅<br/></th>
                                    <th style={{width: "5%"}} scope="col">K₂O<br/></th>
                                    <th style={{width: "5.01%"}} scope="col">S<br/></th>
                                    <th style={{width: "5%"}} scope="col">CaO<br/></th>
                                    <th style={{width: "4.95%"}} scope="col">Mg<br/></th>
                                </tr>
                                </thead>
                            </table>
                            <div id='predecessor-table-container'>
                                <Grid
                                    columns={columnsRegion}
                                    rows={row}
                                    rowHeight={75}
                                    focusOnSingleClick={true}
                                    getRowKey={row => row.id}
                                    isScrollable={false}
                                    disabledCellChecker={(row, columnId) => {
                                        return columnId === 'button_remove' || columnId === 'cropId' || columnId === 'organic';
                                    }}
                                />
                            </div>
                        </div>
                    </Collapse>

                </div> : <div></div>
        );
    }


    render() {
        return (
            PredecessorTable.renderTable(
                this.state.columns,
                this.props.field,
                this.props.crop_list,
                this.props.fertilizer_organic_list,
                this.addRowRegion,
                this.state.columnsRegion,
                this.handleChangeSelectCrops,
                this.handleChangeYieldFact,
                this.handleChangeSelectFertilizer,
                this.props.changeExpand,
                this.props.expand)
        );
    }

    async populateFieldsData() {
        const numberFormat = new Intl.NumberFormat('ru-RU')

        function formatCell(value) {
            return value ? numberFormat.format(value.toString().replace(',', '.')).replace(',', '.') : 0
        }

        const token = await authService.getAccessToken();
        const crops_list = this.props.crop_list;
        const fertilizers_organic_list = this.props.fertilizer_organic_list;

        const onRegionChange = (rowId, field) => (value1) => {
            let value = Number(value1.replace(/\s/g, "").replace(',', '.'))
            const rowRegion = this.props.field[0].regions.find((row) => {
                return row.id === rowId;
            });
            set(rowRegion, field, value);
            this.props.onPredecessorChange(false);
        }

        const onCropChange = (rowId, field) => (value) => {
            const row = this.props.field[0].regions.find((row) => {
                return row.id === rowId;
            })
            set(row, field, value.value);
            this.props.onPredecessorChange(false);
        }

        const onFertilizerChange = (rowId, field) => (value) => {
            const row = this.props.field[0].regions.find((row) => {
                return row.id === rowId;
            });
            row.residue.fertilizerOrganic = this.props.fertilizers.find((f) => {
                return f.id === value.value;
            })
            set(row, field, value.value);
            this.props.onPredecessorChange(false);
        }

        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет данных</Typography>;
        }

        const columnsRegion = [
            {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            placeholder='0'
                            selectTextOnFocus={true}
                            value={row.name}
                            focus={focus}
                            onChange={onRegionChange(row.id, 'name')}
                        />
                    );
                },
                id: 'name',
                width: 6,
                selectTextOnFocus: true
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.area == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.area)}
                                selectTextOnFocus={true}
                                focus={focus}
                                onChange={onRegionChange(row.id, 'area')}
                            />
                        </div>
                    );
                },
                id: 'area',
                width: 8,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Select
                            maxMenuHeight="245px"
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '90%',
                                    height: '53px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '53px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    height: 'fit-content',
                                    wordWrap: 'break-word',
                                    overflow: "hidden",
                                    minHeight: '45px',
                                    lineHeight: '22px',
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar":{
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb":{
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover":{
                                        background: ' #ABB3D1 !important',
                                    }
                                })
                            }}
                            placeholder='Выберите культуру'
                            id="crop-select"
                            options={crops_list}
                            defaultValue={crops_list[crops_list.findIndex((r) => r.value === row.residue.cropId)]}
                            isOpen={focus}
                            onChange={onCropChange(row.id, 'residue.cropId')}
                        />
                    )
                },
                id: 'cropId',
                width: 18,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.residue.yield == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.residue.yield)}
                                selectTextOnFocus={true}
                                focus={focus}
                                onChange={onRegionChange(row.id, 'residue.yield')}
                            />
                        </div>
                    );
                },
                id: 'yield',
                width: 8
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Select
                            maxMenuHeight="260px"
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '90%',
                                    height: '53px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '53px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: '#201E44',
                                    height: 'fit-content',
                                    wordWrap: 'break-word',
                                    overflow: "hidden",
                                    minHeight: '45px',
                                    lineHeight: '22px',
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar":{
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb":{
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover":{
                                        background: ' #ABB3D1 !important',
                                    }
                                })
                            }}
                            placeholder='Выберите удобрение'
                            defaultValue={fertilizers_organic_list[fertilizers_organic_list.findIndex((r) => r.value === row.residue.fertilizerOrganicId)]}
                            options={fertilizers_organic_list}
                            isOpen={focus}
                            onChange={onFertilizerChange(row.id, 'residue.fertilizerOrganicId')}
                        />
                    );
                },
                id: 'organic',
                width: 24,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.residue.fertilizerCount == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.residue.fertilizerCount)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'residue.fertilizerCount')}
                            />
                        </div>
                    )
                },
                id: 'fertilizerCount',
                width: 6,
            },
            {
                title: '',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.residue.mineralElement.n == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.residue.mineralElement.n)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'residue.mineralElement.n')}
                            />
                        </div>
                    );
                },
                id: 'element.n',
                width: 5
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.residue.mineralElement.p2O5 == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.residue.mineralElement.p2O5)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'residue.mineralElement.p2O5')}
                            />
                        </div>
                    );
                },
                id: 'p2o5',
                width: 5
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.residue.mineralElement.k2O == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.residue.mineralElement.k2O)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'residue.mineralElement.k2O')}
                            />
                        </div>
                    );
                },
                id: 'k2o',
                width: 5
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.residue.mineralElement.s == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.residue.mineralElement.s)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'residue.mineralElement.s')}
                            />
                        </div>
                    );
                },
                id: 'S',
                width: 5
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.residue.mineralElement.caO == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.residue.mineralElement.caO)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'residue.mineralElement.caO')}
                            />
                        </div>
                    );
                },
                id: 'cao',
                width: 5
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.residue.mineralElement.mg == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.residue.mineralElement.mg)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'residue.mineralElement.mg')}
                            />
                        </div>
                    );
                },
                id: 'mg',
                width: 5
            }
        ];
        this.setState({token: token, columnsRegion: columnsRegion});

    }

}
